export default __webpack_public_path__ + "static/media/dangerIcon.e32e1b2e.svg";